import { fetch } from '../request';
import type {
  ApplicationTag,
  IResponse,
  RequestConfig,
  ScenariosTag,
  TagParams,
  TagType,
} from '../interface';

// 标签分类
export const getTagsType = () => {
  return fetch('/tags/tag_type/', {
    method: 'GET',
    credential: false,
  });
};

// 标签
export const getTags = (
  params: {
    group?: 'template' | 'character';
    tag_filter?: 'index' | 'template_center' | 'create_project';
    is_tree?: boolean;
  },
  config?: RequestConfig
) => {
  return fetch<IResponse<TagType>>('/tags/get_all/', {
    method: 'GET',
    params: {
      group: params.group || 'template',
      // tag_filter: params.tag_filter || 'template_center',
      is_tree: params.is_tree,
    },
    credential: false,
    ...config,
  });
};

export const getApplicationTags = () =>
  fetch<IResponse<ApplicationTag[]>>(
    '/promotion_center/application_scene/service_platform_application_tags/',
    {
      method: 'GET',
      credential: false,
    }
  );

// 通过 outer_id 获取标签 id
export const getTagByOuterId = (outer_id: string) => {
  return fetch<
    IResponse<
      {
        id: number;
        name: string;
      }[]
    >
  >('/tags/get_tag_by_outer_id/', {
    method: 'GET',
    params: {
      outer_id,
    },
    credential: false,
  });
};

export const getScenariosTags = (config?: RequestConfig) =>
  fetch<IResponse<ScenariosTag[]>>('/tags/get_all_template_applications_tags/', {
    method: 'GET',
    credential: false,
    ...config,
  });

export const getTemplateTags = (params: TagParams) =>
  fetch<IResponse<TagType>>('/tags/filter_valid_tags/', {
    params,
    credential: false,
  });
